import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { encryptTransform } from "redux-persist-transform-encrypt";

const encryptionTransforms = [
  encryptTransform({
    secretKey: process.env.REACT_APP_STORE_SECRET || "fallback-secret-key",
    onError: (error) => {
      console.error("Encryption failed:", error.message);
    },
  }),
];

const isDisableDevtool = () => {
  return process.env.NODE_ENV === "production" && window.location.href.includes("webpunchprod");
};


const persistConfig = {
  key: "root",
  storage,
  whitelist: ["dashboard"],
  transforms: encryptionTransforms,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: !isDisableDevtool(),
});

export const persistor = persistStore(store);

export default store;
